import type { PortableTextComponents } from "@portabletext/react";
import type { PortableTextBlock } from "@portabletext/types";

import { PortableText } from "@portabletext/react";
import { clampListItemLevels } from "./clamp-list-item-levels";
import { getBlockTextContent } from "./get-block-text-content";
import { RichTextGap } from "./RichTextGap";

function createNestedComponents(
  baseComponents: PortableTextComponents,
): PortableTextComponents {
  return {
    ...baseComponents,
    block: {
      ...((baseComponents.block as Record<string, unknown>) || {}),
      normal({ children, value }) {
        if (!getBlockTextContent(value?.children)) {
          return <RichTextGap />;
        }

        return <span className="block">{children}</span>;
      },
    } as PortableTextComponents["block"],
  };
}

function hasVisibleRichTextContent(blocks: PortableTextBlock[]): boolean {
  return blocks.some((block) => {
    if (block._type !== "block" || !Array.isArray(block.children)) {
      return true;
    }

    if (block.listItem) {
      return true;
    }

    return Boolean(getBlockTextContent(block.children));
  });
}

function renderPortableTextInline(
  blocks: PortableTextBlock[],
  mergedComponents: PortableTextComponents,
) {
  if (!hasVisibleRichTextContent(blocks)) {
    return null;
  }

  const nestedComponents = createNestedComponents(mergedComponents);
  return (
    <PortableText
      components={nestedComponents}
      value={clampListItemLevels(blocks)}
    />
  );
}

export { renderPortableTextInline };
